import { Box, Flex, Heading, Image, Link, Text } from "@chakra-ui/react";
import { truncate } from "../../../core/utils";
import { getArticleLink } from "../articleLink";

const Article = ({ article }) => {
  const { title, description, source, date, image } = article;
  const articleLink = getArticleLink(article);

  return (
    <Flex
      direction="column"
      borderRadius="lg"
      overflow="hidden"
      bg="gray.700"
      height="100%" // Ensure the card can grow to fill parent space
      maxH={"500px"}
    >
      {/* Image container that stretches */}
      <Box flex="1" overflow="hidden">
        <Link href={articleLink}>
          <Image
            src={image}
            alt={title}
            objectFit="cover"
            width="100%"
            height="100%"
          />
        </Link>
      </Box>

      {/* Bottom content */}
      <Box p="6">
        <Text fontSize="small" color="red.400">
          {source}
        </Text>
        <Link href={articleLink}>
          <Heading as="h4" size="md" mb="3">
            {title}
          </Heading>
        </Link>
        <Box as="p" color="gray.400" fontSize="sm">
          {truncate(description, 120)}
        </Box>
        <Text pt="1" fontSize="small" color="gray.200">
          {date}
        </Text>
      </Box>
    </Flex>
  );
};

export default Article;
